<template>
  <section>
    <md-list>
      <md-list-item
        v-for="(item, index) in menuData"
        :key="item.cat"
        :to="'/category/' + index"
      >
        <span class="md-list-item-text" @click="selectCat(item.cat)">{{
          item.cat
        }}</span>
      </md-list-item>
    </md-list>
  </section>
</template>

<script>
import { eventBus } from "../../eventbus";
export default {
  name: "ChooseCategory",

  methods: {
    selectCat: function (cat) {
      eventBus.updateDialogTitle(cat.cat);
    },
  },
  computed: {
    menuData() {
      return this.$store.state.menuData;
    },
  },
};
</script>

<style>
</style>